<template>
  <section class="section-form-sent">
    <div class="wrapper">
      <div class="icon">
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M39.9974 73.3327C58.4069 73.3327 73.3307 58.4088 73.3307 39.9993C73.3307 21.5899 58.4069 6.66602 39.9974 6.66602C21.5879 6.66602 6.66406 21.5899 6.66406 39.9993C6.66406 58.4088 21.5879 73.3327 39.9974 73.3327Z" stroke="#009F68" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M55.0294 28L34.3627 48.6667L24.9688 39.2727" stroke="#009F68" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h2 class="title" v-if="props.title">
        {{ props.title }}
      </h2>
      <div class="editor" v-if="props.text" v-html="props.text"></div>

      <a :href="props.link" class="btn btn--primary">
        <span class="btn__label">{{ props.link_label }}</span>
      </a>
    </div>
  </section>
</template>
<script setup>
const props = defineProps({
  title: {
    type: String,
    default: 'Obrigado! Formulário enviado com sucesso.'
  },
  text: {
    type:String,
  },
  link: {
    type:String,
    default: '/'
  },
  link_label: {
    type:String,
    default: 'Voltar para atendimento',
  }
})
</script>
